const storageItemName = "argento_compare";

const getItems = () => {
    const raw = localStorage.getItem(storageItemName) || "[]";

    try {
        return JSON.parse(raw);
    } catch (error) {
        // console.log(error);
    }

    return [];
};

const exists = (candidate) =>
    !!getItems().find(
        (item) =>
            item.handle === candidate.handle &&
            item.variant === candidate.variant
    );

const add = (candidate) => {
    if (!exists(candidate)) {
        let items = getItems();

        items.push(candidate);
        localStorage.setItem(storageItemName, JSON.stringify(items));
    }
};

const remove = (candidate) => {
    let items = getItems();

    items = items.filter(
        (item) =>
            item.handle !== candidate.handle &&
            item.variant !== candidate.variant
    );
    localStorage.setItem(storageItemName, JSON.stringify(items));
};

export { getItems, exists, add, remove };
